import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  detailsRowWise: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
  },
  rowLabel: {
    color: theme.TextColor,
    display: "inline-block",
    maxWidth: 265,
    fontSize: 14
  },
});

const WithRowLabel = (WrappedComponent) =>
  withStyles(styles)(({ classes, rowLabel, rowDescription, customClasses, ...otherProps }) => (
    <div className={customClasses?.detailsColumnWise || classes.detailsRowWise}>
      {rowLabel &&
        <span className={customClasses?.headerStyle || classes.rowLabel}>
          {rowLabel}
        </span>
      }
      {rowDescription &&
        <span className={customClasses?.rowDescription}>
          {rowDescription}
        </span>
      }
      <div>
        <WrappedComponent {...otherProps} />
      </div>
    </div>
  ));

export default WithRowLabel;
